import "./AboutIqac.scss";
import Lines from '../../components/Lines';
import { aboutIqac } from './AboutIQAC';
import TableComponent from '../../components/Table/TableComponent';

const AboutIqac = () => {

    const columns = ["S.No.", "Name", "Designation", "Members"];

    return (
        <section className="aboutIqacMainContainer">
            <header className="aboutIqac">
                <div className="iqacHeader">
                    <h2>About IQAC</h2>
                    <span className="lines-parent">
                        <Lines count={25} color="#116C4A" fontSize={2.3} spacing={0.1} thickness={700} />
                    </span>
                </div>
                <p>
                    Internal Quality Assurance Cell or IQAC was established to assist educational institutes to improve their work strategies and reach out to desired learning outcomes and objectives. IQAC always initiates, plans, and supervises the several quality culture activities that are necessary to increase the quality of the education delivered in the institutes. This structure develops a system for consistent, conscious actions so that institutes can improve their academic and administrative performance. The cell acts as a participative and facilitative unit that works combined with faculty members to come up with the best strategies. It oversees the implementation of quality standards in teaching, learning, evaluation, and research. The cell promotes measures for institutional functioning on the quality enhancement front through the internalization of standard quality culture and best practices.
                </p>
            </header>

            <article className="iqacVision">
                <h2>Vision</h2>
                <p> "To Implement a system for conscious, consistent, and catalytic improvement in the overall performance of the institution. Its vision typically reflects the commitment to enhancing quality in all aspects of higher education, ensuring accountability, and fostering a culture of excellence."</p>
            </article>

            <article className="iqacMission">
                <h2>Mission</h2>
                <p>"To develop a system for conscious, consistent, and catalytic improvement in the overall performance of the institution by promoting measures for institutional functioning towards quality enhancement through internalization of quality culture and institutionalization of best practices."</p>
            </article>

            <article className="iqacCompositionTable">
                <h2>IQAC Composition</h2>
                <TableComponent columns={columns} data={aboutIqac} />
            </article>
        </section>
    )
}

export default AboutIqac
